import PriorityNavScroller from 'priority-nav-scroller';

(function(){
    'use strict';

    if ($('.a-z').length){

        $('.a-z__strip a').each(function(){
            var text = $(this).text();
            var flag = false;
            
            $('.a-z__title').each(function(i){
                if($(this).text() == text) {
                    flag = true;
                }
            });

            if(!flag) {
                $(this).addClass('disabled');
            }
        });
        
        function checkStripOffset() {
            if($('.a-z').offset().top - 1 < window.pageYOffset) {
                $('.a-z__strip').addClass('fixed');
            } else {
                $('.a-z__strip').removeClass('fixed');
            }
        }

        setTimeout(function(){
            var scrollableStrip = PriorityNavScroller({
                scrollStep: 100
            });
        }, 1000);

        $(window).scroll(function() {
            checkStripOffset();
        });

        checkStripOffset();
    }

}());
